import React from "react";
import { SadFace } from "@fidget/common/components/icons/sadFace/sadFace";
import { L10n } from "@fidget/common/i18n";
import { BeforeLoginSection } from "../components/beforeLoginSection";

interface Props {
  version?: "organisation" | "agent";
}

export const TokenExpiredSection: React.SFC<Props> = ({ version }) => (
  <BeforeLoginSection styleType={"signup"}>
    <header>
      <h2>
        <L10n id={"signup.expired"} />
      </h2>
      <SadFace style={{ margin: "auto" }} />
    </header>
    <p>
      {(version === "organisation" && <L10n id={"signup.expiredOrg.description"} />) || (
        <L10n id={"signup.expiredAgent.description"} />
      )}
    </p>
  </BeforeLoginSection>
);
